import React, { useMemo } from 'react'
import { RECEPTOR_TYPE } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { useListDirectoryScanSettings } from 'src/pages/Evidence/evidence.hooks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'
import { getReceptorFilterValues } from './FilterDropdown.helpers'
import { LoadingFilterDropdown } from './FilterDropdown.components'

export const DocumentScanFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data: directoryScanSettings, isLoading: isDirectoryLoading } =
      useListDirectoryScanSettings()

    const receptorFilterValues = useMemo(() => {
      const types = [
        RECEPTOR_TYPE.RECEPTOR,
        RECEPTOR_TYPE.COLLABORATION_SYSTEM,
        RECEPTOR_TYPE.GRC_PLATFORM,
        RECEPTOR_TYPE.WORKFLOW_PLATFORM,
      ]

      const allValues = types.flatMap((type) => getReceptorFilterValues(type))
      // Filter out duplicate 'None' and sort
      const uniqueValues = allValues.filter(
        (v, i, a) =>
          (v.value !== 'none' ||
            i === a.findIndex((t) => t.value === 'none')) &&
          i === a.findIndex((t) => t.value === v.value),
      )
      return uniqueValues.sort((a, b) => {
        const aLabel = typeof a.label === 'string' ? a.label : ''
        const bLabel = typeof b.label === 'string' ? b.label : ''
        return aLabel.localeCompare(bLabel)
      })
    }, [])

    if (isDirectoryLoading) {
      return (
        <LoadingFilterDropdown
          filterName={FilterName.SOURCE}
          isNested={isNested}
        />
      )
    }

    const folderScanFilterValues =
      directoryScanSettings?.getSettingsList().map((setting) => ({
        value: `folder:${setting.getId()}`,
        label: `Folder Scan: ${setting.getName() || setting.getRootPath()}`,
      })) || []

    const connectorFilterValues = receptorFilterValues
      .filter((v) => v.value !== 'none')
      .map((v) => ({
        value: `connector:${v.value}`,
        label: `Connector: ${v.label}`,
      }))

    const filterValues = [
      { value: 'none', label: 'None' },
      ...connectorFilterValues,
      ...folderScanFilterValues,
    ]

    return (
      <FilterDropdown
        filterParam={FilterParam.SOURCE}
        filterName={FilterName.SOURCE}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
